import I18n from "^/config/i18n";

function categoryValues() {
  return [
    {
      value: "",
      key: I18n.t("EventsOver all categories"),
    },
    {
      value: "Vortrag",
      key: I18n.t("EventsOver lecture"),
    },
    {
      value: "Workshop",
      key: I18n.t("EventsOver workshop"),
    },
    {
      value: "Get Together",
      key: I18n.t("EventsOver get together"),
    },
    {
      value: "Seminar",
      key: I18n.t("EventsOver seminary"),
    },
    {
      value: "Symposium/Kolloquium",
      key: I18n.t("EventsOver symposium colloquium"),
    },
    {
      value: "Informationsveranstaltung",
      key: I18n.t("EventsOver information event"),
    },
  ];
}

export default categoryValues;
